(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  /*
    Smart sticky header. The whole header section sticks (offset by the
    announcement bar, which scrolls away), slides up out of view while the
    visitor scrolls toward the footer and glides back as soon as they scroll
    toward the top. A small travel threshold stops it flickering on trackpad
    jitter; it never hides while a menu, search or drawer is open.
  */
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this;
        this.type = this.getAttribute('data-sticky-type');
        this.alwaysVisible = this.type === 'always' || this.type === 'reduce-logo-size';
        this.announcement = this.section.querySelector('.ma-header__announcement');
        this.predictiveSearches = this.querySelectorAll('predictive-search');
        this.preventReveal = false;
        this.preventHide = false;
        this.lastY = window.scrollY;
        this.anchorY = this.lastY;

        this.section.classList.add('ma-sticky-header');
        this.measure = this.measure.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.measure();
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this.section);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        this.resizeObserver && this.resizeObserver.disconnect();
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScroll);
      }

      measure() {
        const ann = this.announcement ? this.announcement.offsetHeight : 0;
        this.section.style.setProperty('--ma-ann-h', `${ann}px`);
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
        this.threshold = this.section.offsetHeight;
      }

      busy() {
        return (
          this.preventHide ||
          !!this.querySelector('details[open]') ||
          [...this.predictiveSearches].some((s) => s.isOpen) ||
          document.body.classList.contains('overflow-hidden') ||
          document.body.classList.contains('overflow-hidden-tablet') ||
          document.body.classList.contains('overflow-hidden-mobile')
        );
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const y = Math.max(0, window.scrollY);
          const down = y > this.lastY;
          if (down !== this.goingDown) { this.anchorY = this.lastY; this.goingDown = down; }
          this.lastY = y;

          this.section.classList.toggle('ma-sticky-header--scrolled', y > this.threshold);
          this.classList.toggle('scrolled-past-header', y > this.threshold);

          if (this.alwaysVisible || y <= this.threshold) return this.setHidden(false);
          const travel = Math.abs(y - this.anchorY);
          if (down && travel > 8 && !this.busy()) this.setHidden(true);
          else if (!down && travel > 4) {
            if (this.preventReveal) {
              clearTimeout(this.revealTimer);
              this.revealTimer = setTimeout(() => (this.preventReveal = false), 120);
              return;
            }
            this.setHidden(false);
          }
        });
      }

      setHidden(hidden) {
        if (this.section.classList.contains('ma-sticky-header--hidden') === hidden) return;
        this.section.classList.toggle('ma-sticky-header--hidden', hidden);
        if (hidden) {
          this.closeMenuDisclosure();
          this.closeSearchModal();
        }
      }

      // kept for Dawn callers (media gallery, cart drawer)
      hide() { if (!this.alwaysVisible) this.setHidden(true); }
      reveal() { this.setHidden(false); }
      reset() { this.setHidden(false); }

      closeMenuDisclosure() {
        this.querySelectorAll('header-menu').forEach((d) => d.close && d.close());
      }

      closeSearchModal() {
        this.querySelectorAll('details-modal').forEach((m) => m.close && m.close(false));
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  /*
    Desktop dropdowns: spring-in / ease-out panels on hover (fine pointers) and
    click. Works for every <details> level in the inline menu: top-level panels
    float in (fade + lift + slight scale), nested lists unfold in height, and the
    rows settle in a short stagger. Without JS Dawn's plain <details> still works.
  */
  (() => {
    if (window.__maMenuMotion) return;
    window.__maMenuMotion = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const SPRING = 'cubic-bezier(0.32, 0.72, 0, 1)';
    const OUT = 'cubic-bezier(0.4, 0, 1, 1)';

    const panelOf = (d) => d.querySelector(':scope > summary + *');
    const isNested = (d) => !!d.parentElement.closest('.header__submenu');

    const open = (d) => {
      clearTimeout(d._maTimer);
      if (d.open && !d._maClosing) return;
      if (d._maAnim) d._maAnim.cancel();
      d._maClosing = false;
      // one top-level (or sibling) panel at a time
      d.closest('ul').querySelectorAll(':scope > li > details[open], :scope > li > header-menu > details[open]').forEach((o) => o !== d && close(o, true));
      d.open = true;
      d.querySelector(':scope > summary').setAttribute('aria-expanded', 'true');
      const panel = panelOf(d);
      if (!panel || reduce.matches) return;
      if (isNested(d)) {
        d._maAnim = panel.animate([{ height: '0px', opacity: 0 }, { height: `${panel.scrollHeight}px`, opacity: 1 }], { duration: 380, easing: SPRING });
        panel.style.overflow = 'hidden';
        d._maAnim.onfinish = () => (panel.style.overflow = '');
      } else {
        d._maAnim = panel.animate(
          [
            { opacity: 0, transform: 'translateY(-8px) scale(0.97)', filter: 'blur(3px)' },
            { opacity: 1, transform: 'none', filter: 'blur(0)' }
          ],
          { duration: 420, easing: SPRING }
        );
      }
      panel.querySelectorAll(':scope > li').forEach((li, i) =>
        li.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }], {
          duration: 360, delay: 40 + i * 28, easing: SPRING, fill: 'backwards'
        })
      );
    };

    const close = (d, instant) => {
      clearTimeout(d._maTimer);
      if (!d.open || d._maClosing) return;
      const panel = panelOf(d);
      d.querySelectorAll('details[open]').forEach((n) => close(n, true));
      const done = () => {
        d._maClosing = false;
        d.open = false;
        d.querySelector(':scope > summary').setAttribute('aria-expanded', 'false');
      };
      if (instant || !panel || reduce.matches) return done();
      d._maClosing = true;
      if (d._maAnim) d._maAnim.cancel();
      d._maAnim = isNested(d)
        ? panel.animate([{ height: `${panel.offsetHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: OUT })
        : panel.animate(
            [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-4px) scale(0.98)' }],
            { duration: 180, easing: OUT }
          );
      if (isNested(d)) panel.style.overflow = 'hidden';
      d._maAnim.onfinish = () => { panel.style.overflow = ''; if (d._maClosing) done(); };
    };

    const bind = (root) => {
      root.querySelectorAll('.header__inline-menu details').forEach((d) => {
        if (d._maBound) return;
        d._maBound = true;
        const summary = d.querySelector(':scope > summary');
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          d.open && !d._maClosing ? close(d) : open(d);
        });
        d.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && d.open) { e.stopPropagation(); close(d); summary.focus(); }
        });
        const li = d.closest('li');
        li.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !finePointer.matches) return;
          clearTimeout(d._maTimer);
          d._maTimer = setTimeout(() => open(d), 70);
        });
        li.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse' || !finePointer.matches) return;
          clearTimeout(d._maTimer);
          d._maTimer = setTimeout(() => close(d), 220);
        });
      });
    };

    const init = () => document.querySelectorAll('.ma-header').forEach(bind);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    document.addEventListener('shopify:section:load', init);
    // click outside closes everything
    document.addEventListener('click', (e) => {
      if (e.target.closest('.header__inline-menu')) return;
      document.querySelectorAll('.ma-header .header__inline-menu details[open]').forEach((d) => close(d));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
